import {
  Flex,
  Stack,
  Heading,
  Text,
  Fieldset,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { authService } from 'src/service/AuthService';
import CancelButton from 'src/components/buttons/CancelButton';
import { Avatar } from "@/components/ui/avatar";
import { Alert } from "@/components/ui/alert"
import { EmailIcon } from '@/components/icons/Icon';
import { useForm, SubmitHandler } from "react-hook-form";
import SubmitButton from '@/components/buttons/SubmitButton';
import { FormInput } from '@/components/fields/FormInput';

interface ForgotPasswordEntry {
  email: string;
}

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordEntry>({
    defaultValues: {
      email: '',
    }
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmitForgot: SubmitHandler<ForgotPasswordEntry> = (entry) => {
    console.info('email forgot...');
    setIsLoading(true);
    authService.passwordForgot(entry.email).then(() => {
      console.info(`${entry.email} forgot requested...`);
      setSuccess(true);
    }).catch(err => {
      console.error(`${entry.email} forgot requested failed:`, err);
      if (err.status === 401) {
        setSuccess(true);
      } if (err.status === 409) {
        setSuccess(true);
        setError('Bitte überprüfe deine E-Mails');
      } else {
        setSuccess(false);
        setError('Ungültiger E-Mail');
      }
    }).finally(() => setIsLoading(false));
  };

  return (
    <>
      <Stack gap={8} mx={'auto'} maxW={'lg'} minH={{ base: '40vh', lg: '75vh' }} py={6} px={6}
        justify={'center'}
      >
        <Stack align={'center'}>
          <Avatar bg="teal.500" />
          <Heading fontSize={'4xl'} textAlign={'center'}>Passwort vergessen?</Heading>
          <Text fontSize={'lg'} color={'gray.600'}>Gib hier deine E-Mail Adresse an, und du bekommst einen Link zugeschickt, mit dem du dein Passwort zurücksetzen kannst. 🔓</Text>
        </Stack>
        <form noValidate onSubmit={handleSubmit(onSubmitForgot)}>
          <Fieldset.Root size='md' maxW='md' invalid={error && error.length > 0} rounded={'lg'}
            boxShadow={'lg'}
            py='3rem'
            px='2rem'
          >
            <Fieldset.ErrorText>
              {error}
            </Fieldset.ErrorText>
            <Stack gap={4}>
              {success && <Alert status='success'>Geschickt!</Alert>}
              <FormInput
                name="email"
                label="E-Mail"
                register={register}
                error={errors.email}
                readOnly={success}
                required
                icon={EmailIcon}
                autoFocus={true}
                type="email"
                rules={{ required: 'E-Mail ist erforderlich' }}
              />
              <Flex justifyContent='flex-end' gap='2' flexWrap='wrap'>
                <CancelButton onClick={() => navigate('/')} />
                {!success && <SubmitButton caption='Link zusenden' isSubmitting={isLoading} />}
              </Flex>
            </Stack>
          </Fieldset.Root>
        </form>
      </Stack >
    </>
  );
}

export default ForgotPassword
